import CancellableQueue from "./CancellableQueue";

export default interface Cancellable {
	cancel(): void;
};

export abstract class AbstractCancellable implements Cancellable {
	private active = true;

	protected constructor(
		private readonly queue?: CancellableQueue
	) {
		if (queue !== undefined) {
			queue.enqueue(this);
		}
	}

	public cancel() {
		if (this.active) {
			this.active = false;
			this.doCancel();
		}
	}

	protected abstract doCancel(): void;

	protected isActive(): boolean {
		return this.active && (this.queue === undefined || this.queue.isActive());
	}
}
